import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'src/components/layouts/Container/Container';
import HeadlineWithButtons from 'src/components/ui/HeadlineWithButtons/HeadlineWithButtons';

function Apps() {
  const { t } = useTranslation();
  return (
    <Container>
      <HeadlineWithButtons headline={t('navbar.apps')} />
    </Container>
  );
}

export default Apps;
